// extracted by mini-css-extract-plugin
module.exports =  {"provider-logo":"_02712f2b3b--provider-logo--hjeBQ","placeholder-logo":"_02712f2b3b--placeholder-logo--nRJOy","bank-logo":"_02712f2b3b--bank-logo--k3lQd"};